import { Form, Formik } from 'formik';
import React, { useContext, useState } from 'react';
import ReactExport from 'react-export-excel';
import * as Yup from 'yup';
import { apiReportBoltOn } from '../../api/api-reports';
import { TourTypeContext } from '../../contexts/tour-type-context';
import { Button, ButtonSubmit, ErrorDisplay, InputDate, PageTitle } from '../common';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ReportBoltOn = () => {
    const [error, setError] = useState(undefined);
    const [data, setData] = useState(undefined);
    const { tourTypeId } = useContext(TourTypeContext);

    const formSchema = Yup.object().shape({
        purchasedFrom: Yup.date().nullable().typeError('Invalid'),
        tourFrom: Yup.date().nullable().typeError('Invalid'),
    });

    return (
        <div className="max-w-screen-lg my-2 sm:m-4 md:mx-auto">
            <div className="sm:rounded-lg shadow-md bg-white sm:px-4 py-4 mb-2">
                <PageTitle title="Bolt-On Report" />

                <Formik
                    initialValues={{ puchasedFrom: '', tourFrom: '' }}
                    enableReinitialize
                    validationSchema={formSchema}
                    onSubmit={async (values) => {
                        setData(undefined);
                        setError(undefined);
                        if (!values.purchasedFrom && !values.tourFrom) {
                            setError('Please enter one of the dates');
                            return;
                        }

                        const result = await apiReportBoltOn(tourTypeId, values.purchasedFrom, values.tourFrom);

                        setData(result);
                    }}>
                    {({ isSubmitting }) => (
                        <Form>
                            <div className="flex gap-2 items-center mb-1">
                                <div className="leading-3 text-sm font-semibold w-36">Purchased From:</div>
                                <InputDate name="purchasedFrom" />
                            </div>
                            <div className="flex gap-2 items-center mb-1">
                                <div className="leading-3 text-sm font-semibold w-36">Tour From:</div>
                                <InputDate name="tourFrom" />
                            </div>
                            <div className="mt-4">
                                <span className="font-semibold">Note:</span> Report runs for a month from the selected date.
                            </div>

                            <ButtonSubmit isSubmitting={isSubmitting} className="mt-4" label="Run" />
                            <ErrorDisplay error={error} />
                        </Form>
                    )}
                </Formik>

                {data && (
                    <ExcelFile element={<Button label="Download" className="mt-2" />} filename="Glide Bolt-On Report">
                        <ExcelSheet data={data.reportRows} name="Data">
                            <ExcelColumn label="Bolt-On" value="boltOn" />
                            <ExcelColumn label="Amount" value="boltOnAmount" />
                            <ExcelColumn label="Price Each" value="boltOnPriceEach" />

                            <ExcelColumn label="Created Date" value={(col) => col.createdDate.substring(0, 10)} />
                            <ExcelColumn label="Tour Date" value={(col) => col.tourDate.substring(0, 10)} />
                            <ExcelColumn label="Tour Time" value="tourTime" />

                            <ExcelColumn label="G2 Booking Id" value="g2BookingId" />
                            <ExcelColumn label="Order Id" value="orderId" />
                            <ExcelColumn label="Invoice Id" value="invoiceId" />

                            <ExcelColumn label="Lane" value="lane" />
                            <ExcelColumn label="Private" value={(col) => (col.isPrivate ? 'Yes' : 'No')} />

                            <ExcelColumn label="Name" value="name" />
                            <ExcelColumn label="Contact Number" value="contactNumber" />
                            <ExcelColumn label="Email" value="email" />
                            <ExcelColumn label="Seats Booked" value="seatsBooked" />
                            <ExcelColumn label="Price Paid" value="pricePaid" />
                            <ExcelColumn label="Payment Method" value="paymentMethod" />
                            <ExcelColumn label="IsPaid" value={(col) => (col.isPaid ? 'Yes' : 'No')} />
                            <ExcelColumn label="Source" value="sourceName" />
                            <ExcelColumn label="Company" value="companyId" />
                            <ExcelColumn label="Affiliate" value="affiliateName" />
                            <ExcelColumn label="Total Ticket Price" value="totalTicketPrice" />
                            <ExcelColumn label="Total BoltOn Price" value="totalBoltOnPrice" />
                            <ExcelColumn label="Deposit Paid" value="depositPaid" />
                            <ExcelColumn label="Discount Code" value="discountCode" />
                            <ExcelColumn label="Notes" value="notes" />
                        </ExcelSheet>
                    </ExcelFile>
                )}
            </div>
        </div>
    );
};

export default ReportBoltOn;
